import Cookies from "js-cookie";
import { ACCESS_TOKEN_KEY, COOKIE_OPTIONS, REFRESH_TOKEN_KEY } from "../hooks/useCookies";

function updateCookies(token: string, refreshToken: string) {
    Cookies.set(ACCESS_TOKEN_KEY, token, {
        ...COOKIE_OPTIONS,
        expires: 7,
    });
    Cookies.set(REFRESH_TOKEN_KEY, refreshToken, {
        ...COOKIE_OPTIONS,
        expires: 30,
    });
}
export default updateCookies;
